import { AlphanumericRegex } from "@sf-core";

const schema = () => {
  const s = {
    type: "object",
    properties: {
      name: {
        type: "string",
        minLength: 3,
        pattern: AlphanumericRegex,
      },
      userSubscriptionEnabled: {
        type: "boolean",
      },
      benchmarkDataFilterEnabled: {
        type: "boolean",
      }, 
    },
    required: ["name"],
  };

  return s;
};

export default schema;
